<p-card
  [header]="product.name"
  class="product"
  styleClass="product mb-4"
  id="product-{{ product.productId }}"
  [attr.data-name]="product.name"
  [attr.data-price]="product.price">
  <ng-template pTemplate="header">
    <img
      alt="Imagen de producto: {{ product.name }}"
      [src]="product.image_url"
      class="max-w-full" />
  </ng-template>
  <div class="p-card-subheader">
    <p-tag
      value="{{ product.price.toFixed(2) }} €"
      styleClass="w-6rem text-lg text-center" />
  </div>
  <div [innerHTML]="product.description"></div>
  <ng-template pTemplate="footer" class="mt-auto">
    <div class="flex gap-3 mt-1">
      <p-button
        (click)="
          product.restaurant_product_type_id === 1
            ? selectProductIngredients()
            : addToCart(product)
        "
        [label]="
          product.restaurant_product_type_id === 1
            ? 'Añadir'
            : 'Añadir a carrito'
        "
        class="w-full"
        styleClass="w-full cart-add" />
    </div>
  </ng-template>
</p-card>
